// Material ui core
import { Grid, Button, IconButton, TextField } from '@material-ui/core';

// Material ui icons
import CloseIcon from '@material-ui/icons/Close';
import { PaginationOrders } from 'interfaces/pagination.interface';
import { useState } from 'react';

interface Props {
  pagination: PaginationOrders;
  setPagination(pagination: PaginationOrders): void;
  handleSearch(searchText: string): void;
  hideSearch(): void;
}

const CustomToolBarOrders: React.FC<Props> = ({ pagination, setPagination, handleSearch, hideSearch }) => {
  const [searchText, setSearchText] = useState<string>('');

  return (
    <div style={{ padding: '15px 0', backgroundColor: 'white' }}>
      <Grid container justify="flex-start" alignItems="center" spacing={2}>
        <Grid item>
          <TextField
            autoFocus
            variant="outlined"
            margin="dense"
            id="input-search"
            name="Search"
            label="Buscar"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                const newPagination: PaginationOrders = { ...pagination, search: searchText, page: 1 };
                setPagination(newPagination);
                handleSearch(searchText);
              }
            }}
            InputProps={{
              autoFocus: true,
              autoComplete: 'off',
              endAdornment: (
                <IconButton size="small" onClick={hideSearch}>
                  <CloseIcon />
                </IconButton>
              )
            }}
            fullWidth
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            onClick={() => {
              const newPagination: PaginationOrders = { ...pagination, search: searchText, page: 1 };
              setPagination(newPagination);
              handleSearch(searchText);
            }}
          >
            BUSCAR
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
export default CustomToolBarOrders;
